import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "WebPage",
   "@id": "https://www.futurefamilyai.com/providers/emr-integration/#webpage",
   "url": "https://www.futurefamilyai.com/providers/emr-integration/",
   "name": "EMR Integration for Patient-Generated Data | FutureFamilyAI",
   "description": "How FutureFamilyAI brings consented home BP and wellness trends into clinical workflows — current capabilities, verification steps and what to ask.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "EMR Integration",
     "item": "https://www.futurefamilyai.com/providers/emr-integration/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "Can patient-generated data go into Epic?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "It can, when the organization has the appropriate interfaces and agreements. FutureFamilyAI confirms Epic connectivity per organization after verification."
     }
    },
    {
     "@type": "Question",
     "name": "What format is the data shared in?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Summaries are available as structured reports; interface formats are confirmed during implementation."
     }
    },
    {
     "@type": "Question",
     "name": "How is patient consent handled?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Patients authorize sharing with your practice in the app and can revoke it. Revocation stops future sharing."
     }
    },
    {
     "@type": "Question",
     "name": "Is the data HIPAA compliant?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Security and privacy practices, including business associate arrangements, are reviewed with each organization during implementation. Request documentation from our team."
     }
    },
    {
     "@type": "Question",
     "name": "How long does integration take?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Timelines depend on your EMR, interfaces and approvals; they are scoped during the demo."
     }
    },
    {
     "@type": "Question",
     "name": "Can we start without integration?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. Many practices begin with shared summaries and add integration later."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function ProvidersEmrIntegrationPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <span>EMR Integration</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                EMR integration for patient-generated health data means bringing
                consented home readings into the clinical record in a format
                clinicians can trust.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Physicians, practice administrators, health IT</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      Patient-generated health data is health-related data
                      created, recorded or gathered by patients to help address
                      a health concern. (ONC / HealthIT.gov)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Consent captured before any data moves · Clearly labeled
                      sources (cuff vs. wearable) · Honest integration status —
                      verified per site
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">PILLAR GUIDE · PROVIDERS</span>
            <h1>EMR Integration for Patient-Generated Pregnancy Data</h1>
            <p className="ffh-answer speakable-content">
              EMR integration for patient-generated health data means bringing
              consented home readings into the clinical record in a format
              clinicians can trust. FutureFamilyAI shares validated-cuff
              readings, wearable trends and symptom reports as structured
              summaries today; direct EMR connectivity, including Epic, is
              enabled only after technical and contractual verification for each
              organization. Discuss integration with our team.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/contact-us?type=physician"
              >
                Request a Clinical Demo
              </Link>
              <Link
                className="ffh-btn ffh-ghost"
                to="/partners/join-referral-network"
              >
                Join the Partner Network — No Fees
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Clinical and IT team discussing EMR integration of patient-generated data"
              >
                <figcaption>
                  <b>Photo slot</b> · Two clinicians and an IT lead around a
                  conference table with a laptop, collaborative meeting in a
                  hospital office. Screens blurred or angled away; no text.
                  <br />
                  <b>Alt:</b> Clinical and IT team discussing EMR integration of
                  patient-generated data
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    Patient-generated health data is health-related data
                    created, recorded or gathered by patients to help address a
                    health concern.
                    <cite>
                      Source:{" "}
                      <a href="https://www.healthit.gov/topic/scientific-initiatives/pcor/patient-generated-health-data-pghd">
                        ONC / HealthIT.gov
                      </a>
                    </cite>
                  </li>
                  <li>
                    The USPSTF recommends screening for hypertensive disorders
                    of pregnancy with blood pressure measurements throughout
                    pregnancy.
                    <cite>
                      Source:{" "}
                      <a href="https://www.uspreventiveservicestaskforce.org/uspstf/recommendation/hypertensive-disorders-pregnancy-screening">
                        USPSTF, 2023
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>What gets shared</h2>
                <ul>
                  <li>Time-stamped validated-cuff blood pressure readings.</li>
                  <li>Symptom reports captured with each reading.</li>
                  <li>
                    Wearable wellness trends, labeled as such (heart rate, PRV,
                    sleep, activity).
                  </li>
                  <li>Color status history and care-team review notes.</li>
                </ul>
              </section>
              <section id="s2">
                <h2>How integration is verified</h2>
                <p>
                  Each organization receives a current integration matrix,
                  security documentation and interface specifications. Nothing
                  is described as live until it has been demonstrated in that
                  environment.
                </p>
              </section>
              <div className="ffh-inline-cta">
                <p>No partner fees. Our care team handles patient setup.</p>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=physician"
                >
                  Request a Clinical Demo
                </Link>
              </div>
              <section id="s3">
                <h2>Consent and governance</h2>
                <p>
                  Patients authorize sharing with a specific practice.
                  Revocation stops future sharing. Your organization&apos;s
                  policies govern what enters the chart.
                </p>
              </section>
              <section id="s4">
                <h2>Next step</h2>
                <p>
                  Request a demo with your IT and clinical leads to review
                  current capabilities, timelines and requirements.
                </p>
              </section>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>Can patient-generated data go into Epic?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        It can, when the organization has the appropriate
                        interfaces and agreements. FutureFamilyAI confirms Epic
                        connectivity per organization after verification.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>What format is the data shared in?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Summaries are available as structured reports; interface
                        formats are confirmed during implementation.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How is patient consent handled?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Patients authorize sharing with your practice in the app
                        and can revoke it. Revocation stops future sharing.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Is the data HIPAA compliant?</summary>
                    <div className="ffh-ans">
                      <p>
                        Security and privacy practices, including business
                        associate arrangements, are reviewed with each
                        organization during implementation. Request
                        documentation from our team.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How long does integration take?</summary>
                    <div className="ffh-ans">
                      <p>
                        Timelines depend on your EMR, interfaces and approvals;
                        they are scoped during the demo.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Can we start without integration?</summary>
                    <div className="ffh-ans">
                      <p>
                        Yes. Many practices begin with shared summaries and add
                        integration later.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/contact-us?type=physician"
                  >
                    Request a Clinical Demo
                  </Link>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/partners/join-referral-network"
                  >
                    Join the Partner Network — No Fees
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">RG</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Rashmi Gulati, MD</h3>
                  <p>
                    Medical Director, Patients Medical. Dr. Rashmi Gulati, MD,
                    is Medical Director of Patients Medical, a Manhattan
                    practice founded in 1974. She leads FutureFamilyAI&apos;s
                    physician and care-team content and medically reviews every
                    page on this site.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/providers">For Physicians →</Link>
                  <Link to="/providers/epic-integration-patient-generated-data">
                    Epic Patient-Generated Data →
                  </Link>
                  <Link to="/providers/physician-dashboard-pregnancy-monitoring">
                    Physician Dashboard →
                  </Link>
                  <Link to="/providers/how-to-recommend-future-family">
                    Recommend FutureFamilyAI →
                  </Link>
                  <Link to="/providers/clinical-protocol-acog-smfm">
                    Clinical Protocol →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                  <a href="https://www.patientsmedical.com">
                    https://www.patientsmedical.com →
                  </a>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">What gets shared</a>
                  </li>
                  <li>
                    <a href="#s2">How integration is verified</a>
                  </li>
                  <li>
                    <a href="#s3">Consent and governance</a>
                  </li>
                  <li>
                    <a href="#s4">Next step</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Partner with FutureFamilyAI</b>
                <span>No fees. Free directory listing.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=physician"
                >
                  Request a Clinical Demo
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
